// Import controller interfaces
import {
    IProductController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    DisqualifiersText,
    PossibleBuildingUse,
    PossibleConstructionType,
    PossibleFoundationType,
    PossibleOccupancyType,
    PossibleParkingType,
    PossiblePeril,
    ValidNewBusinessInceptionDateBoundaries,
} from '@app/models/api';
// Import enumerations.
import {
    BroadLineOfBusiness,
    Peril,
} from '@app/enumerations';

export default class MockProductController implements IProductController {

    public constructor() {
        
    }

    public async getValidNewBusinessInceptionDateBoundaries(): Promise<ValidNewBusinessInceptionDateBoundaries> {
        throw new Error("Method not implemented.");
    }

    public async getPossiblePerilsAndDeductibles(broadLineOfBusinessCode: BroadLineOfBusiness, state: string): Promise<PossiblePeril[]> {
        throw new Error("Method not implemented.");
    }

    public async getPossibleBuildingUses(broadLineOfBusinessCode: BroadLineOfBusiness): Promise<PossibleBuildingUse[]> {
        throw new Error("Method not implemented.");
    }

    public async getPossibleOccupancyTypes(broadLineOfBusinessCode: BroadLineOfBusiness): Promise<PossibleOccupancyType[]> {
        throw new Error("Method not implemented.");
    }

    public async getPossibleParkingTypes(broadLineOfBusinessCode: BroadLineOfBusiness): Promise<PossibleParkingType[]> {
        throw new Error("Method not implemented.");
    }

    public async getPossibleFoundationTypes(broadLineOfBusinessCode: BroadLineOfBusiness): Promise<PossibleFoundationType[]> {
        throw new Error("Method not implemented.");
    }

    public async getPossibleConstructionTypes(broadLineOfBusinessCode: BroadLineOfBusiness): Promise<PossibleConstructionType[]> {
        throw new Error("Method not implemented.");
    }

    public async getDisqualifiersText(perilCodes: Peril[], broadLineOfBusinessCode: BroadLineOfBusiness): Promise<DisqualifiersText> {
        throw new Error("Method not implemented.");
    }
};